import { CommonModule } from "@angular/common";
import { Component, inject, model, signal } from "@angular/core";
import { rxResource } from "@angular/core/rxjs-interop";
import { DocumentTemplateCategoryService } from "@malirang/api-client";
import {
    Badge,
    Button,
    Input,
    ModalAdapter,
    ModalContainer,
    ModalHeader,
} from "@malirang/front-share";
import { CenterStore } from "../../../../../stores/center/center.store";
import { DocumentCategoryItemComponent } from "./document-category-item/document-category-item.component";
import {
    CdkDragDrop,
    CdkDropList,
    moveItemInArray,
} from "@angular/cdk/drag-drop";

export type ManageDocumentCategoryModalProps = {};

@Component({
    selector: "app-manage-document-category",
    templateUrl: "./manage-document-category.modal.html",
    styleUrls: ["./manage-document-category.modal.css"],
    imports: [
        CommonModule,
        ModalHeader,
        ModalContainer,
        Input,
        Button,
        DocumentCategoryItemComponent,
        CdkDropList,
        Badge,
    ],
})
export class ManageDocumentCategoryModal extends ModalAdapter<ManageDocumentCategoryModalProps> {
    readonly categoryService = inject(DocumentTemplateCategoryService);
    readonly centerStore = inject(CenterStore);

    value = model<string>("");

    $categories = rxResource({
        stream: () =>
            this.categoryService.documentTemplateCategoryControllerFindAll({
                centerId: this.centerStore.currentCenterId(),
            }),
    });
    categories = this.$categories.value;

    isAdded = signal<boolean>(false);

    handleClose() {
        this.close(this.isAdded());
    }

    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(
            this.categories() || [],
            event.previousIndex,
            event.currentIndex,
        );

        this.confirmOrder();
    }

    confirmOrder() {
        const body = this.categories()?.map((item, index) => ({
            id: item.id,
            order: index,
        }));

        this.categoryService
            .documentTemplateCategoryControllerUpdateOrder({
                body: body || [],
            })
            .subscribe({
                next: () => {
                    this.toastService.success("적용되었습니다.");
                },
                error: (err) => {
                    this.toastService.error(err.message);
                },
            });
    }

    submit() {
        if (this.value()) {
            this.categoryService
                .documentTemplateCategoryControllerCreateDocument({
                    body: {
                        name: this.value(),
                    },
                    centerId: this.centerStore.currentCenterId(),
                })
                .subscribe(() => {
                    this.$categories.reload();
                    this.value.set("");
                    this.isAdded.set(true);
                });
        }
    }
}
